namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class ExcelColumnEditor extends Serenity.Select2AjaxEditor<EcxelColumnOption, object> {


        public _lastRequest: JQueryXHR;
        public option: EcxelColumnOption;
        private _path: string;

        constructor(hidden: JQuery, opt: EcxelColumnOption) {
            super(hidden, opt);
            this.option = opt;
        }


        public destroy(): void {
            super.destroy();
        }
        public getItemKey(item: string): string {
            return item.toString();
        }

        public getItemText(item: string): string {
            return item;
        }

        public getTypeDelay(): number {
            return 500;
        }


        protected queryByKey(key: string, callback: (p1: any) => void): void {
            var options: Serenity.ServiceOptions<any> = {
                blockUI: false,
                service: "/Services/Nobox/Campaign/GetExcelColoumnRetrieve",
                request: { Search: key, Path: this.Path },
                onSuccess: function (response) {
                    callback(response.Entity);
                }
            };
            this.executeQueryByKey(options);
        }

        protected getService(): string {
            return "/Services/Nobox/Campaign/GetExcelColoumn";
        }

        public GetIncludeColumns(): string[] {
            return [];
        }

        public executeQuery(options: Serenity.ServiceOptions<Serenity.ListResponse<string>>): void {
            var customOptions = {} as Serenity.ServiceOptions<Serenity.ListResponse<string>>;
            var request = {} as Serenity.ListRequest;
            request.Path = this.Path;
            customOptions.request = request;
            customOptions.blockUI = false;
            customOptions.onSuccess = options.onSuccess;
            customOptions.url = "/Services/Nobox/Campaign/GetExcelColoumn";
            customOptions.error = () => {
            };

            if (this._lastRequest != null && this._lastRequest.readyState != XMLHttpRequest.DONE)
                this._lastRequest.abort();

            this._lastRequest = Q.serviceCall(customOptions);
            var self = this;
            this._lastRequest.then(() => self._lastRequest = null, () => self._lastRequest = null);
        }

        public get UploadEditor(): any {
            return this.option.UploadEditor;
        }

        public set UploadEditor(val) {
            if (this.UploadEditor != val) {
                this.option.UploadEditor = val;
            }
        }

        public get Path(): string {
            var editor = Q.findElementWithRelativeId(this.element, this.UploadEditor).tryGetWidget(Serenity.FileUploadEditor);
            var value = JSON.stringify(editor.value);
            if (Q.isEmptyOrNull(editor.value)) {

            } else {
                value = editor.value.Filename
            }
            return value;
        }

        public set Path(val) {
            if (this._path != val) {
                this._path = val;
                this.value = null;
            }
        }

    }
    export class EcxelColumnOption {
        UploadEditor: string;
    }

}